<template>
    <v-container fluid>   
      <LeftMenu/>     
      <v-tabs
        v-model="tab"
        fixed-tabs          
        background-color="white"
        color="black accent-4"
        left
      >
        <v-tab key="products">
          Products
        </v-tab>
        <v-tab key="categories">
          Product Categories
        </v-tab> 
        <v-tab key="terms">
          Offer Terms
        </v-tab> 
      </v-tabs>
       <v-tabs-items v-model="tab">
        <v-tab-item
          key="products"
        >
          <v-layout row wrap>   
            <v-flex xs12>&nbsp;</v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs10>
            <v-data-table
              :headers="headers"
              :items="productsComputed"
              :items-per-page="50"
              item-key="id"
              sort-by="product"
              class="elevation-1"
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Products</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New Product</v-btn>
                      <v-flex xs12 sm6 md2>
                        <v-switch color="red" v-model="showPassive" class="mx-2" label="Show Passive"></v-switch>  
                      </v-flex>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md10>
                              <v-text-field v-model="editedItem.model" label="Product Name"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                              <v-switch color="green" v-model="editedItem.active" class="mx-2" label="Active"></v-switch>  
                            </v-flex>  
                            <v-flex xs6 sm6 md6>
                              <v-combobox
                                :items="categories"
                                label="Select Category"
                                v-model="editedItem.category"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>   
                            <v-flex xs6 sm6 md6>
                              <v-combobox
                                :items="units"
                                label="Select Unit"
                                v-model="editedItem.unit"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>   
                            <v-flex xs12 sm6 md12>
                              <v-textarea v-model="editedItem.explanation"  :outlined="true"
                              :auto-grow="true" :clearable="true"
                              label="Explanation"></v-textarea>
                            </v-flex>                                                                                                                                                                       
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
              </template> 
              <template v-slot:body.append>                    
              </template>             
              <template v-slot:item.action="{ item }">              
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs1></v-flex>
        </v-layout>
        </v-tab-item>
        <v-tab-item key="categories">
          <v-layout row wrap>   
            <v-flex xs12>&nbsp;</v-flex>
            <v-flex xs1></v-flex>
            <v-flex xs10>
                <ProductCategories :terms-list="termsList" @productCategoryChanged="refreshCategories"/>             
            </v-flex>
            <v-flex xs1 />    
          </v-layout> 
        </v-tab-item>  
        <v-tab-item key="terms">
          <v-layout row wrap>   
            <v-flex xs12>&nbsp;</v-flex>
            <v-flex xs1></v-flex>
            <v-flex xs10>
                <OfferTerms @offerTermChanged="refreshTerms"/>             
            </v-flex>
            <v-flex xs1 />    
          </v-layout> 
        </v-tab-item>    
      </v-tabs-items>
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
import ProductCategories from '../definitions/ProductCategories';
import OfferTerms from '../definitions/OfferTerms';
const API_URL = 'definitions/products';
const CATEGORIES_URL = 'definitions/productCategories';
const UNITS_URL = 'definitions/productUnits';
const TERMS_API_URL = 'definitions/offerTerms';
export default {
    components:{
      LeftMenu,
      ProductCategories,
      OfferTerms
    },
    data () {
    return {
      tab: null, 
      dialog: false,
      showPassive : false,
      search: '',
      products: [],
      termsList: [],
      categories: [],
      units: [],
      editedIndex: -1,
      editedItem: {
        model: '',
          category: '',
          explanation: '', 
      },
      defaultItem: {
        model: '',
          category: '',
          explanation: '', 
      },
    }
  },
  computed: {
    headers () {
      return [
        {
          text: 'Product Name',
          align: 'left',
          sortable: true,
          value: 'model',
        },
        { text: 'Category',  value: 'category.text'  },
        { text: 'Unit',  value: 'unit.text'  },
        { text: 'Explanation',  value: 'shortExplanation'  }, 
         { text: 'Status',  value: 'status'  },         
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Product' : 'Edit Product'
    },
    productsComputed(){
      return this.products.map((item) => {   
        item.shortExplanation = item.explanation.substr(0,100);    
        item.status = item.active ? 'Active' : 'Passive';
        return item;    
      })
    },
  },
  created() {    
    this.getProductCategories();
    this.getProductUnits();
    this.getProducts(this.showPassive);
    this.getOfferTerms();
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    showPassive(showPassive){     
      this.getProducts(showPassive);
    },
  },
  methods: {
    refreshCategories(){
      this.getProductCategories();
    },
    refreshTerms(){
      this.getOfferTerms();
    },
    editItem (item) {
      this.editedIndex = this.products.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.products.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.products.splice(index, 1);
        this.deleteProduct(item);
      } 
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if(!this.editedItem.unit){
        alert('Product Unit  cannot be empty!');
        return;
      }
      if(!this.editedItem.category){
        alert('Product Category  cannot be empty!');
        return;
      }
      if (this.editedIndex > -1) {        
        this.updateProduct(this.editedItem);
      } else {
        this.addProduct(this.editedItem);         
      }      
    },
    addProduct(item){
      this.$axios.post(this.$apiurl + API_URL, {
        model: item.model,
        categoryId: item.category ? item.category.id : null,
        unitId: item.unit ? item.unit.id : null,
        explanation: item.explanation,
        active: item.active ? 1 : 0
      })
      .then(response => {        
        if (response.status === 201) {
          this.products.push(this.editedItem);
          this.getProducts();
          this.close();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateProduct(item){
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        model: item.model,
        categoryId: item.category ? item.category.id : null,
        unitId: item.unit ? item.unit.id : null,
        explanation: item.explanation,
        active: item.active ? 1 : 0
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.products[this.editedIndex], this.editedItem);
          this.getProducts();
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deleteProduct(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getProductCategories(){     
        this.$axios.get(this.$apiurl + CATEGORIES_URL)
            .then(response => {
                this.categories = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getProductUnits(){     
        this.$axios.get(this.$apiurl + UNITS_URL)
            .then(response => {
                this.units = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getProducts(showPassive){     
      var url = this.$apiurl + API_URL;
      if(showPassive){
        url += '/status/'+false;
      }else{
         url += '/status/'+true;
      }
      this.$axios.get(url)
          .then(response => {
              this.products = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },
    getOfferTerms(){     
      this.$axios.get(this.$apiurl + TERMS_API_URL)
          .then(response => {
              this.termsList = response.data;
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
